import { ApiTokensPanel } from "./ApiTokensPanel";

interface SettingsPageProps {
  className?: string;
}

export function SettingsPage({ className }: SettingsPageProps) {
  return (
    <div className={className}>
      <ApiTokensPanel />
    </div>
  );
}
